import React, { Component } from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import history from './history';
import './App.css';
import HomePage from './Containers/HomePage';
import ScrollToTop from './Components/ScrollToTop';

class App extends Component {
  render() {
    return (
      <Router history={history} onUpdate={() => window.scrollTo(0, 0)} >
        <ScrollToTop>
          <div>
            <Switch>
              <Route name="home" exact path="/" component={HomePage} />
            </Switch>
          </div>
        </ScrollToTop>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js